import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatInt, formatYyyymmddDisplay } from '@/features/dashboard-finance/formatters';

/** Cancelamentos (`TENANT_SUSPENDED`) por dia BRT no período. */
export function CancellationsChart({
  series,
}: {
  series: readonly { yyyymmdd: string; count: number }[];
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({ x: formatYyyymmddDisplay(d.yyyymmdd), y: d.count }));
  return (
    <BiTimeChart
      title={t('sales.charts.cancellations')}
      type="bar"
      data={data}
      color="#ef4444"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
